import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

export default function LookupFieldConfiguration({ draftField, handleDraftFieldChange, collections = [] }) {
  const { t } = useTranslation();
  const selectedCollection = collections.find((col) => col.id === draftField.lookupCollectionId);
  const collectionFields = selectedCollection?.fields || [];
  const selectableFields = [{ name: '_id' }, ...collectionFields];

  return (
    <>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-12 mt-4">
        <div className="sm:col-span-6">
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('customCollections.form.lookup.targetCollection')}</label>
          <div className="grid grid-cols-1">
            <select
              name="lookupCollectionId"
              value={draftField.lookupCollectionId || ''}
              onChange={(e) => {
                const collection = collections.find((col) => col.id === e.target.value);
                handleDraftFieldChange({ target: { name: 'lookupCollectionId', value: e.target.value, type: 'text' }});
                handleDraftFieldChange({ target: { name: 'lookupCollectionName', value: collection?.name || '', type: 'text' }});
                handleDraftFieldChange({ target: { name: 'lookupLinkField', value: '', type: 'text' }});
                handleDraftFieldChange({ target: { name: 'lookupDisplayField', value: '', type: 'text' }});
              }}
              className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
            >
              <option value="">{t('customCollections.form.lookup.selectCollection')}</option>
              {collections.map((col) => (
                <option key={col.id} value={col.id}> {col.name} </option>
              ))}
            </select>
            <ChevronDownIcon aria-hidden="true" className="pointer-events-none col-start-1 row-start-1 mr-2 size-4 self-center justify-self-end text-gray-400"/>
          </div>
        </div>

        <div className="sm:col-span-6">
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('customCollections.form.lookup.linkField')}</label>
          <div className="grid grid-cols-1">
            <select
              name="lookupLinkField"
              value={draftField.lookupLinkField || ''}
              onChange={handleDraftFieldChange}
              disabled={!draftField.lookupCollectionId}
              className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:bg-gray-100"
            >
              <option value="">{t('customCollections.form.lookup.selectField')}</option>
              {selectableFields.map((field) => (
                <option key={field.name} value={field.name}>
                  {field.name}
                </option>
              ))}
            </select>
            <ChevronDownIcon aria-hidden="true" className="pointer-events-none col-start-1 row-start-1 mr-2 size-4 self-center justify-self-end text-gray-400"/>
          </div>
        </div>

        <div className="sm:col-span-6">
          <label className="block text-xs font-medium text-gray-700 mb-1">{t('customCollections.form.lookup.displayField')}</label>
          <div className="grid grid-cols-1">
            <select
              name="lookupDisplayField"
              value={draftField.lookupDisplayField || ''}
              onChange={handleDraftFieldChange}
              disabled={!draftField.lookupCollectionId}
              className="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-sm text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 disabled:bg-gray-100"
            >
              <option value="">{t('customCollections.form.lookup.selectField')}</option>
              {selectableFields.map((field) => (
                <option key={field.name} value={field.name}>
                  {field.name}
                </option>
              ))}
            </select>
            <ChevronDownIcon
              aria-hidden="true"
              className="pointer-events-none col-start-1 row-start-1 mr-2 size-4 self-center justify-self-end text-gray-400"
            />
          </div>
        </div>
      </div>

      <p className="mt-3 text-[11px] text-gray-500">
        {t('customCollections.form.lookup.hint')}
      </p>
    </>
  );
}
